import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormBase from './formBase';
import { formPersonalProperties } from '../../fixtures/formPersonalProperties';
import JsonForm from "react-jsonschema-form";

const schema = {
  type: 'object',
  required: [ 'numberOfPersons' ],
  properties: {
    numberOfPersons: {
      type: 'string',
      title: 'Number of proprietors/partners/directors/guarantors?',
      enum: ['1', '2', '3', '4'],
      default: '1'
    }
  },
  dependencies: {
    numberOfPersons: {
      oneOf: [
        {
          properties: {
            numberOfPersons: {
              enum: ['1']
            },
            person1: {
              title: `Director/Guarantor 1 Details`,
              '$ref': '#/definitions/personalDetails'
            }
          }
        },
        {
          properties: {
            numberOfPersons: {
              enum: ['2']
            },
            person1: {
              title: `Director/Guarantor 1 Details`,
              '$ref': '#/definitions/personalDetails'
            },
            person2: {
              title: `Director/Guarantor 2 Details`,
              '$ref': '#/definitions/personalDetails'
            }
          }
        },
        {
          properties: {
            numberOfPersons: {
              enum: ['3']
            },
            person1: {
              title: `Director/Guarantor 1 Details`,
              '$ref': '#/definitions/personalDetails'
            },
            person2: {
              title: `Director/Guarantor 2 Details`,
              '$ref': '#/definitions/personalDetails'
            },
            person3: {
              title: `Director/Guarantor 3 Details`,
              '$ref': '#/definitions/personalDetails'
            }
          }
        },
        {
          properties: {
            numberOfPersons: {
              enum: ['4']
            },
            person1: {
              title: `Director/Guarantor 1 Details`,
              '$ref': '#/definitions/personalDetails'
            },
            person2: {
              title: `Director/Guarantor 2 Details`,
              '$ref': '#/definitions/personalDetails'
            },
            person3: {
              title: `Director/Guarantor 3 Details`,
              '$ref': '#/definitions/personalDetails'
            },
            person4: {
              title: `Director/Guarantor 4 Details`,
              '$ref': '#/definitions/personalDetails'
            }
          }
        }
      ]
    }
  },
  definitions: {
    address: {
      type: 'object',
      required: [ 'streetAddress', 'city', 'postcode', 'state' ],
      properties: {
        streetAddress: {
          title: 'Street address',
          type: 'string'
        },
        city: {
          title: 'City',
          type: 'string'
        },
        postcode: {
          title: 'Postcode',
          minLength: 4,
          maxLength: 4,
          type: 'string'
        },
        state: {
          title: 'State',
          type: 'string',
          enum: [
            'New South Wales', 'Victoria', 'Queensland', 'Western Australia',
            'South Australia', 'Tasmania', 'Australian Capital Territory', 'Northern Territory'
          ]
        }
      }
    },
    personalDetails: {
      type: 'object',
      required: [
        'fullName', 'email', 'guarantorType', 'residentialAddress', 'dateOfBirth', 'homePhone', 'mobile', 'maritalStatus',
        'dependents', 'residentialStatus'
      ],
      properties: {
        fullName: {
          type: 'string',
          title: 'Name in full'
        },
        email: {
          type: 'string',
          title: 'Email',
        },
        guarantorType: {
          type: 'string',
          title: 'Guarantor Type',
          enum: ['director', 'guarantor'],
          enumNames: ['director', 'non-director']
        },
        residentialAddress: {
          '$ref': '#/definitions/address',
          title: 'Residential address'
        },
        dateOfBirth: { // todo format date
          type: 'string',
          title: 'Date of birth'
        },
        homePhone: {
          type: 'string',
          title: 'Home phone'
        },
        mobile: {
          type: 'string',
          title: 'Mobile'
        },
        maritalStatus: {
          type: 'string',
          title: 'Marital status',
          enum: ['Single', 'Married', 'Separated', 'Widowed', 'Divorced']

        },
        dependents: {
          type: 'number',
          title: 'No. of dependants'
        },
        residentialStatus: {
          type: 'string',
          title: 'Residential status',
          enum: ['Owner occupied', 'Renting', 'Boarding', 'Other']
        },
        otherResidentialStatus: {
          type: 'string', // todo optionally show when Other is chosen
          title: 'Other'
        }
      }
    }
  }
};

const uiSchema = {
  purpose: {
    'ui:placeholder': 'Please choose'
  },
  frequency: {
    'ui:placeholder': 'Please choose'
  },
  person1: {
    dateOfBirth: {
      'ui:placeholder': 'dd/mm/yyyy'
    }
  },
};

const mergedSchema = Object.assign({}, schema, formPersonalProperties());

class FormPersonalDetails extends FormBase {
  static defaultProps = { schema: mergedSchema, uiSchema }
}

const connected = connect(() => {})(FormPersonalDetails);
export default connected;



// WEBPACK FOOTER //
// ./src/containers/Application/formPersonalDetails.js